import baseRoute from '../baseRoute';

export default `${baseRoute}/equipmentCost` as const;
